import { render, staticRenderFns } from "./ChannelManagementCurrencyView.vue?vue&type=template&id=00569214&"
import script from "./ChannelManagementCurrencyView.vue?vue&type=script&lang=js&"
export * from "./ChannelManagementCurrencyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports